import React, { useState } from "react";
import { Row, Accordion, Button } from "react-bootstrap";
import { FaAngleDown } from "react-icons/fa";
const VersionSideBar = props => {
  // eslint-disable-next-line
  const [selectedChild, setSelectedChild] = useState(null);
  const handleChildSelect = (child, parentLink) => {
    setSelectedChild({ ...child, parentLink });
    props.onChildSelect({ ...child, parentLink });
  };

  return (
    <div className="sideBarWrapper">
      <h4 className="version-sideBar-title">{props.sidebar_title}</h4>
      <hr />
      {props.links.map((link, index) => (
        <Row
          className="version-sideBar-content"
          key={index}
          style={{ padding: "5px 10px" }}>
          <div>
            <Accordion>
              <Accordion.Toggle
                as={Button}
                variant="link"
                className="version-link"
                eventKey="0">
                {link.value}
                <FaAngleDown />
              </Accordion.Toggle>
              <Accordion.Collapse className="version-link-menu" eventKey="0">
                <div>
                  {link.children.map((child, childIndex) => (
                    <div
                      className="version-sub-link"
                      key={childIndex}
                      onClick={() => handleChildSelect(child, link)}>
                      {child.title}
                    </div>
                  ))}
                </div>
              </Accordion.Collapse>
            </Accordion>
          </div>
        </Row>
      ))}
    </div>
  );
};

export default VersionSideBar;
